export default __webpack_public_path__ + "static/media/logo.48b1b802.png";